import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  state: {
    isToken: '',
    // isToken: 'eyJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoxMH0.vvHFDaMHjoZ2mRoBDqd_gGK_wYs-7PENgtp7jlxEZ04',
    pathTemporal: null,
    isTestUser: false,
    loginHelper: null
  },
  mutations,
  actions,
  getters
}
